export const userKey = '__authorization_user'
/* LOCAL BACKEND */
/*export const baseApiUrl = 'http://localhost'
export const baseApiPort = '8081'

/* REMOTE BACKEND */
/*export const baseApiUrl = 'http://10.90.0.46'
export const baseApiPort = '80/services'*/

/* AWS BACKEND */
/*export const baseApiUrl = 'http://ec2-18-223-113-165.us-east-2.compute.amazonaws.com'
export const baseApiPort = '80/services'*/

/* AWS BACKEND - HOMOLOG */
/*export const baseApiUrl = 'https://streamlinehomolog.digisystem.com.br'
export const baseApiPort = '/services'

/* AWS BACKEND - HOMOLOG */
export const baseApiUrl = 'https://streamline.digisystem.com.br'
export const baseApiPort = '/services'

export default { userKey, baseApiUrl, baseApiPort }